/* eslint-disable object-curly-newline */
import type { Config, ResolvedRegister } from '@wagmi/core';
import { estimateGas } from '@wagmi/core';
import { encodeFunctionData } from 'viem';
import { UseWriteContractParameters, useWriteContract } from 'wagmi';
import { UseWriteContractReturnType } from 'wagmi/src/hooks/useWriteContract';

import { config } from '@tools/wagmi';

import { toBN } from '@utils/formaters.utils';

import { CHAIN_ID, GAS_MULTIPLIER } from '@constants/common/chain.constants';

export function useWriteContractExtraGas<
  config extends Config = ResolvedRegister['config'],
  context = unknown,
>(
  parameters: UseWriteContractParameters<config, context> = {},
): UseWriteContractReturnType<config, context> {
  const { writeContract, writeContractAsync, ...rest } =
    useWriteContract(parameters);

  type Return = UseWriteContractReturnType<config, context>;

  const onWriteContract = async (
    ...[variables]: Parameters<typeof writeContract>
  ) => {
    const data = encodeFunctionData({
      abi: variables.abi,
      functionName: variables.functionName,
      args: variables.args as any,
    });

    let gas;
    try {
      gas = await estimateGas(config, {
        data,
        to: variables.address,
        account: variables.account,
        value: variables.value,
      }).then((res) =>
        BigInt(
          toBN(res)
            .times(GAS_MULTIPLIER[parameters.config?.state.chainId as CHAIN_ID])
            .toFixed(0),
        ),
      );
    } catch (e) {
      console.error('estimateGas:', e);
    }

    console.log('EstimateGas:', gas);

    return writeContract({
      gas,
      ...variables,
    });
  };

  const onWriteContractAsync = async (
    ...[variables]: Parameters<typeof writeContract>
  ) => {
    const data = encodeFunctionData({
      abi: variables.abi,
      functionName: variables.functionName,
      args: variables.args as any,
    });

    let gas;
    try {
      gas = await estimateGas(config, {
        data,
        to: variables.address,
        account: variables.account,
        value: variables.value,
      }).then((res) =>
        BigInt(
          toBN(res)
            .times(GAS_MULTIPLIER[parameters.config?.state.chainId as CHAIN_ID])
            .toFixed(0),
        ),
      );
    } catch (e) {
      console.error(e);
    }

    return writeContractAsync({
      gas,
      ...variables,
    });
  };

  return {
    writeContract: onWriteContract as Return['writeContract'],
    writeContractAsync: onWriteContractAsync as Return['writeContractAsync'],
    ...rest,
  };
}
